import { AssetCategorization } from "@api";
import { AssetsChartDataItem } from "@components";

export const prepareAssetsChartData = (
  categories?: AssetCategorization
): AssetsChartDataItem[] => {
  const cash: AssetsChartDataItem = {
    name: "cash",
    value: categories?.cashByAccount?.currentMarketValue ?? 0,
  };
  const investments: AssetsChartDataItem = {
    name: "investments",
    value: categories?.investmentTypeAllocation?.currentMarketValue ?? 0,
  };

  return [investments, cash];
};
